import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5111b909"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "super-centered" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logotipo mb-4",
    src: "https://i.imgur.com/Cb4nqcG.png",
    alt: "logo"
  })
], -1))
const _hoisted_3 = { class: "box registration-success-box has-text-centered" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-check-circle fa-6x has-text-success" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "has-text-weight-semibold is-size-5" }, " Parabéns ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "A sua conta foi criada com sucesso!", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 is-size-7 has-text-weight-semibold" }, "Foi enviado um email com instruções sobre como ativar a sua conta.", -1))
const _hoisted_8 = { class: "mt-5" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Área de cliente")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "button is-link",
              to: "/login"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}